/* eslint-disable import/no-anonymous-default-export*/
// eslint-disable import/no-anonymous-default-export
// File was autogenerated by tools/generateLabels.js script

export default {
    ForgotPasswordMessage: "Wysłaliśmy Ci e-mail z instrukcją jak zmienić hasło. Sprawdź swoją skrzynkę i stwórz nowe hasło.",
    SMSPhoneNumberValidationMessage: "Oto Twój kod {0} przekaż go ambasadorowi.\r\nPozdrawiamy zespół Ploom",
};
